import { useHotkeys } from 'react-hotkeys-hook'

/**
 * Registers the Cmd+K / Ctrl+K global keyboard shortcut to open Global Search.
 *
 * `mod` maps to Cmd (⌘) on macOS and Ctrl on other platforms.
 * `enableOnFormTags` and `enableOnContentEditable` allow the shortcut to fire
 * even when focus is on form elements or contenteditable areas.
 */
export const useGlobalSearchHotkey = (open: () => void): void => {
  useHotkeys('mod+k', open, {
    preventDefault: true,
    enableOnFormTags: true,
    enableOnContentEditable: true,
  })
}
